import $axios from '@/plugins/axios-instance'
export default {
    state: {
        userRequestSubjectsList: []
    },
    getters: {
        getUserRequestSubjects(state) {
            return state.userRequestSubjectsList
        }
    },
    actions: {
        getPersonalSettings(context, data) {
            return  $axios.get('/OrganizationSettings/GetPersonalSettings')
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        setPersonalSettings(context, data) {
            return $axios.post('/OrganizationSettings/SetPersonalSettings', data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        getTemplate(context, data) {
            return  $axios.get('/OrganizationSettings/getTemplate')
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        setOrganizationSettings(context, data) {
            return $axios.post('/OrganizationSettings/SetOrganizationSettings', data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        getOrganizationSettings(context, data) {
            return  $axios.get('/OrganizationSettings/GetOrganizationSettings')
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        userRequestSubjects(context) {
            return $axios.get('/OrganizationSettings/userRequestSubjects')
            .then((response) => {
                context.state.userRequestSubjectsList = response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        userRequestCreate(context, data) {
            return $axios.post('/OrganizationSettings/userRequestSubjects', data)
            .then((response) => {
                context.state.userRequestSubjectsList.push(response.data)
            }).catch((e)=>{
                throw(e.response)
            })
        },
        
        userRequestDelete(context, data) {
            return $axios.delete(`/OrganizationSettings/userRequestSubjects?subjectId=${data.id}`)
            .then((response) => {
                context.state.userRequestSubjectsList.splice(data.index, 1)
            }).catch((e)=>{
                throw(e.response)
            })
        },
    }
}
